import close from '../assets/close.svg';
import phone from '../assets/phone.svg';

type Icon = {
  [Name: string]: string;
}

export const icons: Icon = {
  close,
  phone,
};
